import { Formik } from "formik";
import Input from "../shared/Input/Input";
import Button from "@mui/material/Button";
import "./Register.scss";
import { useLazyValidateBpSiteIdQuery } from "../../services/rtkQueryServices/authenticationService";
import { useState } from "react";
import { InstructionsPage } from "./InstructionsPage/InstructionsPage";
import { UserService } from "../../services/UserService";
import { useAuth } from "../../context/AuthProvider";
import * as Yup from "yup";
import { errorMessages } from "../../constants/errorMessages";
import { LOGIN_LITERALS } from "../../constants/literals";
import { regex } from "../../constants/regex";

const BpSiteIdVerification = (props: any) => {
  const { formRef } = props;
  const [validateBpSiteId] = useLazyValidateBpSiteIdQuery();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const auth = useAuth();
  let applicationUserId = auth?.authClaims?.applicationUserId;
  const handleNextPage = () => {
    props.nextStep();
    UserService.currentStep = "3";
  };
  const validationSchema = () =>
    Yup.object({
      bpSiteId: Yup.string().required(errorMessages.required("BP Site ID")),
      pairingCode: Yup.string()
        .required(errorMessages.required("Pairing Code"))
        .matches(
          regex.paringCodeRegex,
          () => errorMessages.invalid_PairingCode_Format
        ),
    });
  return (
    <div className="register-form-container instructions-wrapper d-flex flex-column d-flex flex-column">
      <div className="h-100">
        <div className="register-header text-align-center align-self-center p-4">
          Connect to Inca Evo
        </div>

        <Formik
          innerRef={formRef}
          initialValues={{ bpSiteId: "", pairingCode: "" }}
          validationSchema={validationSchema}
          validateOnChange={true}
          onSubmit={(values) => {
            validateBpSiteId({
              bpSiteId: values.bpSiteId,
              pairingCode: values.pairingCode,
              applicationUserId: applicationUserId,
            })
              .unwrap()
              .then((res) => {
                if (
                  res.data?.isValidBpSiteId &&
                  res.data?.isSuccessfulSqlConnection
                ) {
                  handleNextPage();
                } else if (!res.data?.isValidBpSiteId) {
                  setErrorMessage(
                    errorMessages.invalid_BPSiteID_or_PairingCode
                  );
                } else if (!res.data?.isSuccessfulSqlConnection) {
                  setErrorMessage(errorMessages.cannot_connect_to_BP);
                } else {
                  setErrorMessage(LOGIN_LITERALS.somethingWentWrong);
                }
              })
              .catch((error) => {
                setErrorMessage("Validation failed");
              });
          }}
        >
          {(formik) => (
            <form
              //   onKeyDown={Utility.preventSubmitOnEnter}
              onSubmit={formik.handleSubmit}
              className="d-flex flex-column registration-form instructions-container align-items-center"
            >
              <InstructionsPage />
              <div className="pt-3 bp-site-input">
                <Input
                  name="bpSiteId"
                  placeholder="BP Site ID"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.bpSiteId}
                  errorMsg={
                    (formik.touched.bpSiteId || formik.submitCount > 0) &&
                    formik.errors.bpSiteId &&
                    (formik.errors as any).bpSiteId
                  }
                  maxLength={64}
                  label="BP Site ID"
                  required
                />
                <Input
                  name="pairingCode"
                  placeholder="XXXX-XXXX-XXXX"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.pairingCode}
                  errorMsg={
                    formik.errors.pairingCode &&
                    (formik.errors as any).pairingCode
                  }
                  maxLength={14}
                  label="Pairing Code"
                  required
                />
              </div>
              {errorMessage && (
                <div className="pt-3 error-message align-self-center">
                  {errorMessage}
                </div>
              )}

              <div className="d-flex justify-content-end flex-column gap-3 line-top py-3 registration-form-button register-submission">
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!formik.isValid || !formik.dirty}
                >
                  Submit
                </Button>
                <Button
                  className="link-button"
                  onClick={() => {
                    handleNextPage();
                  }}
                >
                  Skip for now
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default BpSiteIdVerification;
